<mat-chip-list selectable multiple [disabled]="isDisabled">
  <mat-chip *ngFor="let option of options; let i = index;" (click)="toggleSelection(i)" [selected]="selectedOptions[i]">
    {{option}}
  </mat-chip>
</mat-chip-list>
